// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)
import FlashController from "./flash_controller"
application.register("flash", FlashController)
import ListItemFormController from "./list_item_form_controller"
application.register("list-item-form", ListItemFormController)
